async function loadNoLemonsGenres() {
  const target = document.querySelector('[data-nl-home-genres]');
  if (!target) return;
  try {
    const url = new URL(target.dataset.collectionUrl, window.location.origin);
    url.searchParams.set('section_id', 'nl-stock-genres');
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return;
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const navigation = html.querySelector('.nl-stock-browse');
    if (navigation) {
      target.replaceChildren(document.importNode(navigation, true));
      target.hidden = false;
    }
  } catch {
    target.hidden = true;
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadNoLemonsGenres, { once: true });
} else {
  loadNoLemonsGenres();
}
document.addEventListener('shopify:section:load', loadNoLemonsGenres);
